import { cn } from '@/lib/utils';
import { FunctionComponent, PropsWithChildren } from 'react';

export const Section: FunctionComponent<PropsWithChildren & { isCollapsed?: boolean }> = ({ children }) => {
  return <div className={cn('flex flex-col p-2 gap-1 flex-1')}>{children}</div>;
};
